import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { listKeyValueStatus } from 'shared/types';

interface IValidaModal {
  open: boolean;
  status: string;
  alterado:boolean;
  onChangeStatus:(status:string) => void;
  onClose: () => void;
  onSave: () => void;
}

export const AlteracaoStatusModal: React.FC<IValidaModal> = ({
  open,
  status,
  alterado,
  onChangeStatus,
  onClose,
  onSave
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle>{'Alterar Status'}</DialogTitle>
      <DialogContent>
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">Status</FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            value={status}
            name="radio-buttons-group"
            onChange={(event) => onChangeStatus(event.target.value)}
          >
            {listKeyValueStatus.map((status) => (
              <FormControlLabel key={status.key} value={status.key} control={<Radio />} label={status.value} />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          color='primary'
          variant='contained'
          onClick={onClose}
        >
          Cancelar
        </Button>
        <Button
          disabled={!alterado}
          color='primary'
          variant='contained'
          onClick={onSave}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};